import { createFileRoute } from '@tanstack/react-router'
import { ContractsPage } from '~/features/compensation/ContractsPage'
import { NoFinanceAccess } from '~/features/compensation/parts'
import { contractsQuery, loaderSeason } from '~/features/compensation/queries'
import { useCan } from '~/lib/session'

export const Route = createFileRoute('/_app/verein/praemien/vertraege/')({
  loader: async ({ context }) => {
    const s = await loaderSeason(context.queryClient)
    if (s?.canRead) await context.queryClient.ensureQueryData(contractsQuery(s.season))
  },
  component: function Vertraege() {
    return useCan()('finance.read') ? <ContractsPage /> : <NoFinanceAccess title="Verträge" />
  },
})
